import { render } from "./DatePreview.vue?vue&type=template&id=c040b6d6"
import script from "./DatePreview.vue?vue&type=script&lang=js"
export * from "./DatePreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__